import { DeliveriesFilters, DeliveriesSortField, HistoricalSwitch } from 'api/models/Deliveries';
import { SortOrder } from 'api/models/Sorting';
import { atom, useAtom } from 'jotai';

export const PAST_DELIVERIES_INITIAL_FILTERS: DeliveriesFilters = {
  sort_order: SortOrder.Ascending,
  sort_by: DeliveriesSortField.SurgeryDate,
  historical: HistoricalSwitch.Inactive, // only applicable to past deliveries
};

const pastDeliveriesFiltersAtom = atom(PAST_DELIVERIES_INITIAL_FILTERS);

export const usePastDeliveriesFilters = () => useAtom(pastDeliveriesFiltersAtom);
